import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config";
import AccountTypesDropdown from "../Shared/AccountTypesDropdown";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import LoginChecked from "../Shared/LoginChecked";
import {
  Row,
  Col,
  Card,
  DatePicker,
  Button,
  Form,
  Input,
  Select,
  message,
  Collapse,
  Table,
  Modal,
  Upload,
  Alert,
  Typography,
} from "antd";
import {
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { NavLink } from "react-router-dom";
import dayjs from "dayjs";
import { JsonToExcel } from "react-json-to-excel";
import {
  buildSampleImportRows,
  downloadSampleCsv,
  parseAccountsCsv,
} from "./accountImportUtils";

const { Text, Paragraph } = Typography;

function AddAccount(props) {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");

  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [ListOfAccounts, setListOfAccounts] = useState([]);
  const [importOpen, setImportOpen] = useState(false);
  const [importRows, setImportRows] = useState([]);
  const [importLoading, setImportLoading] = useState(false);
  const [importResults, setImportResults] = useState(null);

  const { Option } = Select;
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const accountTypesArray = AccountTypesDropdown();
  const sampleExcelRows = buildSampleImportRows();

  useEffect(() => {
    document.title = "Add Account";
  }, []);

useEffect(()=>{
setLoading(true);
const data={
  UserID:UserID,
  AccessKey:AccessKey,
  NoofRecords:10,
}

var api_config = {
  method: "post",
  url: config.base_url + "Account/GetRecentAccounts",
  headers: {
    "Content-Type": "application/json",
  },
  data: data,
};
axios(api_config)
.then(function (response) {
 
  if (response.data.status_code == 1) {
    setListOfAccounts(response.data.listofAccounts)
    
    setLoading(false);
  } else {
   
    setLoading(false);
  }
  //   setLoading(false);
})
      .catch(function (error) {
        message.error("Network Error");
        console.log(error);
      });
  }, [submitLoading]);

  const handleImportFile = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target?.result;
      if (typeof text !== "string") {
        message.error("Could not read file.");
        return;
      }
      const types = Array.isArray(accountTypesArray) ? accountTypesArray : [];
      const parsed = parseAccountsCsv(text, types);
      if (parsed.length === 0) {
        message.warning("No valid rows found. Check the file format.");
        setImportRows([]);
        return;
      }
      setImportResults(null);
      setImportRows(parsed);
      message.success(`${parsed.length} row(s) ready to import.`);
    };
    reader.readAsText(file);
    return false;
  };

  const runImport = () => {
    if (!importRows.length) {
      message.warning("Upload a CSV file first.");
      return;
    }
    setImportLoading(true);
    const payload = {
      UserID: Number(UserID),
      AccessKey,
      Accounts: importRows.map((r) => ({
        Name: r.Name,
        Mobile_No: r.Mobile_No,
        Phone_No: r.Phone_No,
        Email_Address: r.Email_Address,
        Description: r.Description,
        Account_Type_ID: r.Account_Type_ID,
        OpeningBalance: r.OpeningBalance,
        OpeningBalanceType: r.OpeningBalanceType,
        OpeningDate: r.OpeningDate,
        Account_Type_BE: r.Account_Type ? { Name: r.Account_Type } : null,
      })),
    };
    axios({
      method: "post",
      url: config.base_url + "account/ImportAccounts",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then((res) => {
        const data = res.data;
        setImportResults(data);
        if (data.status_code === 1) {
          messageApi.success(data.status_message);
          setSubmitLoading((s) => !s);
          setImportRows([]);
        } else {
          messageApi.warning(data.status_message || "Import completed with errors.");
        }
        setImportLoading(false);
      })
      .catch(() => {
        message.error("Network Error");
        setImportLoading(false);
      });
  };

  const closeImportModal = () => {
    setImportOpen(false);
    setImportRows([]);
    setImportResults(null);
  };

  const importPreviewColumns = [
    { title: "#", render: (_, __, i) => i + 1, width: 48 },
    { title: "Name", dataIndex: "Name", key: "Name", ellipsis: true },
    { title: "Account Type", dataIndex: "Account_Type", key: "Account_Type" },
    {
      title: "Type ID",
      dataIndex: "Account_Type_ID",
      key: "Account_Type_ID",
      render: (v) =>
        v > 0 ? v : <Text type="danger">Missing</Text>,
    },
    {
      title: "Opening",
      key: "ob",
      align: "right",
      render: (_, r) =>
        r.OpeningBalance
          ? `${r.OpeningBalance} (${r.OpeningBalanceType})`
          : "—",
    },
  ];

  const importResultColumns = [
    { title: "Row", dataIndex: "RowNumber", key: "RowNumber", width: 56 },
    { title: "Name", dataIndex: "Name", key: "Name" },
    {
      title: "Status",
      dataIndex: "Success",
      key: "Success",
      render: (ok) => (ok ? "OK" : "Skipped"),
    },
    { title: "Message", dataIndex: "Message", key: "Message" },
  ];

  const columns = [
    {
      title: "SR",
      dataIndex: "Sr",
      key: "Sr",
      render: (_, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      sorter: true,
    },
    {
      title: "Created Date",
      dataIndex: "Created_Date",
      key: "Created_Date",
      render:(_,record)=>dayjs(record.Created_Date).format(config.date_format)
      
    },
    {
      title: "Account Type",
      dataIndex: "Account_Type_BE", 
      key: "Account_Type_BE",
      render: (accountTypeBE) => {
        
        return accountTypeBE ? accountTypeBE.Name : "";
      },
    },

    
  ];

  const handleSubmit = (formData) => {
    
    setSubmitLoading(true);
    const openingDate = formData.OpeningDate
      ? moment(formData.OpeningDate).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    const openingBalance = parseFloat(formData.OpeningBalance);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      ...formData,
      OpeningDate: openingDate,
      OpeningBalance: Number.isNaN(openingBalance) ? 0 : openingBalance,
    };


    var api_config = {
      method: "post",
      url: config.base_url + "account/AddNewAccount",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

   

    axios(api_config)
      .then(function (response) {
        
        if (response.data.status_code == 1) {
          
          setSubmitLoading(false);
          messageApi.open({
            type: "success",
            content: response.data.status_message,
          });
          form.resetFields();

          // Handle success
        } else {
          // Handle error
          setSubmitLoading(false);
          messageApi.open({
            type: "error",
            content: response.data.status_message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const text = (
    <p
      style={{
        paddingLeft: 24,
      }}
    >
      Enter opening balance and choose <strong>Receivable (Debit)</strong>. The
      system posts a General voucher: Debit the new account, Credit Capital.
      Works for Customer and any other account type.
    </p>
  );
  const text1 = (
    <p
      style={{
        paddingLeft: 24,
      }}
    >
      Enter opening balance and choose <strong>Payable (Credit)</strong>. The
      system posts a General voucher: Debit Capital, Credit the new account.
      Typical for Supplier / Creditors, and available for every account type.
    </p>
  );
  const items = [
    {
      key: "1",
      label: "Opening Balance for Customers",
      children: text,
    },
    {
      key: "2",
      label: "Opening Balance for Suppliers",
      children: text1,
    },
  ];

  return (
    <>
      <LoginChecked />
      {contextHolder}

      <div className="right-side-contents">
        <div className="page-content">
          <Row>
            <Col span={12}>
              <div className="page-header">
                <h6 className="page-title">
                  <NavLink to="/accounts/manage-accounts">
                    <ChevronLeftIcon />
                  </NavLink>
                  Add Account
                </h6>
              </div>
            </Col>
            <Col span={12}>
              <div className="text-end">
                <Button
                  type="primary"
                  size="large"
                  shape="round"
                  style={{ marginBottom: 10 }}
                  onClick={() => setImportOpen(true)}
                >
                  Import Accounts
                </Button>
              </div>
            </Col>
          </Row>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Card>
                <Form
                  name="basic"
                  layout="horizontal"
                  form={form}
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  initialValues={{
                    remember: true,
                    OpeningBalanceType: "Debit",
                    OpeningBalance: 0,
                  }}
                  onFinish={handleSubmit}
                  //    onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  size="large"
                >
                  <Form.Item
                    label="Account Name"
                    name="Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter account name",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Account Name" />
                  </Form.Item>

                  <Form.Item
                    label="Mobile Number"
                    name="Mobile_No"
                  >
                    <Input placeholder="Enter Mobile Number" />
                  </Form.Item>
                  <Form.Item label="Phone Number" name="Phone_No">
                    <Input placeholder="Enter Phone Number" />
                  </Form.Item>
                  <Form.Item label="Email Address" name="Email_Address">
                    <Input placeholder="Enter Email Address" />
                  </Form.Item>
                  <Form.Item label="Description" name="Description">
                    <Input placeholder="Enter Your Description" />
                  </Form.Item>

                  <Form.Item label="Opening Balance" name="OpeningBalance">
                    <Input placeholder="Enter Opening Balance" />
                  </Form.Item>

                  <Form.Item
                    label="Balance Type"
                    name="OpeningBalanceType"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Select placeholder="Select balance type">
                      <Select.Option value="Debit">Receivable</Select.Option>
                      <Select.Option value="Credit">Payable</Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Account Type"
                    name="Account_Type_ID"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      placeholder="Select account type"
                      optionFilterProp="children"
                      // onChange={onChange}
                      // onSearch={onSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      loading={accountTypesArray === false ? true : false}
                      options={accountTypesArray}
                    />
                  </Form.Item>

                  <Form.Item label="Opening Date" name="OpeningDate">
                    <DatePicker />
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      offset: 8,
                      span: 16,
                    }}
                  >
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      htmlType="submit"
                      loading={submitLoading}
                    >
                      Add Account
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Collapse
                items={items}
                bordered={true}
                defaultActiveKey={["1"]}
              />
              <div style={{marginTop:'20px'}}>
              <div className="page-header">
              <h3  className="page-title" style={{fontSize:"24px"}} >
             Recently Added Account
            </h3>
            </div>
              <Table
              size="small"
              scroll={{
                x: "100%",
              }}
              loading={loading}
              columns={columns}
              dataSource={ListOfAccounts}
              pagination={false}
              // onChange={handleTableChange}
              bordered
              />
              </div>
              {/* <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-5">
                                        <h5>Opening Balance for Customers</h5>
                                        <p className="text-muted">Opening balance with Debit type for customers will automatically be added in the system, However, opening balance for all other balance types and accounts will be managed through vouchers. </p>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div>
                                        <h5>Opening Balance for Suppliers</h5>
                                        <p className="text-muted">Opening balance with Credit type for customers will be automatically added in the system, However, opening balance for all other balance types and accounts will be managed through vouchers. </p>
                                    </div>
                                </div>
                            </div> */}
            </Col>
          </Row>
        </div>
      </div>

      <Modal
        title="Import accounts from CSV"
        open={importOpen}
        onCancel={closeImportModal}
        width={900}
        footer={[
          <Button key="cancel" onClick={closeImportModal}>
            Close
          </Button>,
          <Button
            key="import"
            type="primary"
            loading={importLoading}
            disabled={!importRows.length}
            onClick={runImport}
          >
            Import {importRows.length ? `(${importRows.length})` : ""}
          </Button>,
        ]}
        destroyOnClose
      >
        <Paragraph type="secondary">
          Download the sample file, fill in your accounts (one row per account), then
          upload the CSV. <Text strong>Name</Text> and <Text strong>Account_Type</Text>{" "}
          are required. Use account type names exactly as listed below. When{" "}
          <Text strong>OpeningBalance</Text> is non-zero, a General voucher is posted
          against <Text strong>Capital</Text> for every account type (Debit =
          Receivable, Credit = Payable).
        </Paragraph>

        {Array.isArray(accountTypesArray) && accountTypesArray.length > 0 ? (
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 12 }}
            message="Available account types"
            description={accountTypesArray.map((t) => t.label).join(", ")}
          />
        ) : null}

        <div style={{ marginBottom: 16, display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Button
            icon={<DownloadOutlined />}
            onClick={() => downloadSampleCsv()}
          >
            Download sample CSV
          </Button>
          <JsonToExcel
            title="Download sample Excel"
            data={sampleExcelRows}
            fileName="account_import_sample"
            btnClassName="ant-btn"
          />
          <Upload
            accept=".csv,text/csv"
            showUploadList={false}
            beforeUpload={handleImportFile}
          >
            <Button icon={<UploadOutlined />}>Upload CSV file</Button>
          </Upload>
        </div>

        {importRows.length > 0 ? (
          <Table
            size="small"
            bordered
            pagination={{ pageSize: 8 }}
            rowKey={(_, i) => `imp-${i}`}
            columns={importPreviewColumns}
            dataSource={importRows}
            scroll={{ x: true }}
            style={{ marginBottom: 16 }}
          />
        ) : null}

        {importResults?.results?.length ? (
          <>
            <Paragraph>
              Imported: <Text strong>{importResults.importedCount ?? 0}</Text> —
              Skipped: <Text strong>{importResults.skippedCount ?? 0}</Text>
            </Paragraph>
            <Table
              size="small"
              bordered
              pagination={{ pageSize: 8 }}
              rowKey={(r, i) => `res-${r.RowNumber ?? i}`}
              columns={importResultColumns}
              dataSource={importResults.results}
              scroll={{ x: true }}
            />
          </>
        ) : null}
      </Modal>
    </>
  );
}

export default AddAccount;
